import React, { Fragment } from 'react';
import { on_change } from "../../../../shared-functions/on-change";
import { delete_operation } from "../../../../shared-functions/delete-operation";
import custom_warning from "../../../../shared-functions/custom-warning";
import get_time from "../../../../shared-functions/get-time";
import { Option } from 'rc-select';
import { Descriptions, Select, Form, Row, Col, Input, Radio, Collapse, Tag, Button, Modal, notification, DatePicker, InputNumber, Alert } from 'antd';
import { DownloadOutlined, PlusCircleFilled, ExclamationCircleOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { item_type, table_list_type } from '../../contexts/table-list';
import { backup_config_post_process, backup_post_process, backup_schedule_post_process, backup_status, storage_detail, storage_type, check_existed } from "./backup";
import { FormattedMessage } from 'react-intl';
import { IntlFormatters } from '@formatjs/intl';
import moment from "moment";
import FileSaver from "file-saver";
import Cron from "../../backup-restore/cron/cron";
import { IUserInfoType } from '../../../../contexts/user-info';
import { operation_type, props_type_without_router, result_args_type, validate_type } from '../../../../components/new-table-list/interface';
import { http_request, response_type } from '../../../../http-worker/http-func';
import {format_time, http_get} from '../../common-file/service';
import { set_name } from '../../../../shared-functions';
export interface modal_type {
    props: props_type_without_router & backup_management_props;
    formatMessage: any;
    form?: any;
    set_tick: React.Dispatch<React.SetStateAction<any>>;
    validators: validate_type | undefined;
    set_validators: React.Dispatch<React.SetStateAction<validate_type | undefined>>;
    set_special_field_error: React.Dispatch<React.SetStateAction<boolean | undefined>>;
    action: 0 | 1 | 2 | 3;
    operation: operation_type;
    handle_cancel: () => void;
    modal_close: 0 | 1;
    http_result: any;
    special_field_error: boolean | undefined;
    set_disabled: React.Dispatch<React.SetStateAction<boolean>>;
    disabled: boolean;
}

export interface backup_management_props {
    backup_management_list?: any[];
    service_list?: any[],
    instance_datasource?: any,
    instance_item_selected?: any,
    instance_name?: string,
    set_instance_name?: React.Dispatch<React.SetStateAction<string>>,
    service_name: string,
    set_service_name?: React.Dispatch<React.SetStateAction<string>>;
    backup_type?: number,
    // side menu page
    content_sidebar_selected?: string,
    set_content_sidebar_selected?: React.Dispatch<React.SetStateAction<string>>,
    disabled_hours?: boolean,
    set_disabled_hours?: React.Dispatch<React.SetStateAction<boolean>>,
    storage_type_list?: any[]
    format_subscriptions?: any[] | undefined,
    selected_subscriptions?: string,
    user_info?: IUserInfoType,
    sso_subscription_selected: any,
    set_sso_subscription_selected: React.Dispatch<React.SetStateAction<any>>,
    // edit_description?: boolean,
    // set_edit_description?: React.Dispatch<React.SetStateAction<boolean>>,
    // description?: string,
    // set_description?: React.Dispatch<React.SetStateAction<string>>;
    connection_status?: string,
    set_connection_status?: React.Dispatch<React.SetStateAction<string>>;
    month_selected_list?: string[],
    set_month_selected_list?: React.Dispatch<React.SetStateAction<string[]>>,
    month_item_status?: boolean[],
    set_month_item_status?: React.Dispatch<React.SetStateAction<boolean[]>>,
    monthOptions?: string[],
    storage_list?: storage_type[] | undefined,
    backup_config_list?: item_type[] | undefined,
    db_list?: any,
    set_db_list?: React.Dispatch<React.SetStateAction<any>>,
    restore_db_list?: string[] | undefined,
    set_restore_db_list?: React.Dispatch<React.SetStateAction<string[] | undefined>>,
    cron_text?: string,
    set_cron_text?: React.Dispatch<React.SetStateAction<string>>,
    view_log?: string,
    set_view_log?: React.Dispatch<React.SetStateAction<string>>,
    config_schedule_list?: any[] | undefined,
    enable_schedule_list?: any[] | undefined,
    subscription_id?: string,
    storage_type?: string,
    connect_loading?: boolean,
    set_connect_loading?: React.Dispatch<React.SetStateAction<boolean>>,
    result_to_do?: (args: result_args_type) => void,
    selected_config?: item_type | undefined,
    set_selected_config?: React.Dispatch<React.SetStateAction<item_type | undefined>>,
    start_time?: any | undefined,
    set_start_time?: React.Dispatch<React.SetStateAction<any | undefined>>,
    instance_list?: any[] | undefined,
    set_instance_list?: React.Dispatch<React.SetStateAction<any[] | undefined>>,
    set_loading?: React.Dispatch<React.SetStateAction<boolean>>,
    datacenter_name: string | undefined,
    lang?: string,
    table_list?: table_list_type,
    set_table_list?: React.Dispatch<React.SetStateAction<table_list_type>>,
}

export interface backup_management_fields_type {
    backup_name?: string;
    expiry_days?: number;
    configuration_name: string;
    service_name: string;
    instance?: string;
    backup_config: string;
    backup_type: string;
    selected_database: string;
    selected_database_list: string[];
    destination_storage_level1: string,
    backup_destination_storage: string;
    start_time?: any;
    end_time?: any;
    shard?: string;
    retention?: string;
    selected_config?: string;

    schedule_name: string;
    frequency: string;
    cron_time: string;
    backup_once_time: any;
    backup_interval_days: number;
    backup_interval_hours: number;
    backup_start_week: string[];
    backup_start_day: number[];
    backup_configuration: string;
    // db_storage
    storage_name: string;
    storage_type: string;
    subscription_name: string;
    description: string;
    version: string;
    NFS_service: string;
    remote_path: string;
    // restore
    source_database?: string,
    new_database_name?: string,
    time?: string,
    cron?: string,
    instance_name?: string,
    day_time?: any,
    month_time?: any,
    week_time?: any,
    month?: any,
    week?: any,
}

export const backup_operation = (): operation_type[] => {

    const { Panel } = Collapse;
    const { TextArea } = Input;
    const operation_status = (modal_title: string, action: 0 | 1 | 2 | 3 | undefined, caption: string) => ({
        modal_title,
        action,
        caption,
    });

    const backup_config_refresh_url = (props: any) => `/backup/dbBackupConfigs?instanceId=${props.instance_item_selected.instanceId}`;
    const backup_management_refresh_url = (props: any) => `/backup/dbBackups?instanceId=${props.instance_item_selected.instanceId}`;
    // const restore_refresh_url = (props: any) => `/backup/dbRestores?instanceId=${props.instance_item_selected.instance_id}`;
    const backup_schedule_refresh_url = (props: any) => `/backup/dbSchedules?instanceId=${props.instance_item_selected.instanceId}`;

    // 下載
    const download_file = (file_name: any) => {
        // e.stopPropagation();
        (async () => {
            let config: any, blob: any;
            const type = "data:application/json;charset=utf-8";
            try {
                const cluster_config: any =
                    (await fetch(`/v1/backup/config?type=string`, {
                        credentials: "include",
                        method: "GET",
                    }));
                // config = await cluster_config.text();
                if (cluster_config?.status >= 200 && cluster_config?.status < 299) {
                    config = await cluster_config.text();
                } else {
                    config = await cluster_config.text();
                    notification.error({
                        message: "Error",
                        description: <FormattedMessage id="download_error" />
                    });
                }
            } catch {
                config = "API response Error";
                notification.error({
                    message: "Error",
                    description: config
                });
            }
            blob = new Blob([config], { type: type });
            let isFileSaverSupported = false;
            try {
                isFileSaverSupported = !!new Blob();
            } catch (file_name) {
                console.error(file_name);
            }
            isFileSaverSupported && FileSaver.saveAs(blob, file_name || "");
        })();
    }

    const go_storageSettings_confirm = (props: any, formatMessage: any, key: string) => {
        const { set_content_sidebar_selected, set_visible } = props;

        return Modal.confirm({
            width: 540,
            icon: <ExclamationCircleOutlined />,
            content: formatMessage({ id: "confirm_to_storage_settings" }, { type: `${formatMessage({ id: key })}` }),
            okText: formatMessage({ id: "confirm" }),
            cancelText: formatMessage({ id: "cancel" }),
            onOk: () => {
                if (key === "storage_settings") {
                    props.history.push("/storage-settings");
                    sessionStorage.setItem("sidebarKey", 'storage-settings')
                } else {
                    set_visible(0);
                    set_content_sidebar_selected("backup_configuration");
                }
            }
        })
    };

    const backup_handle_ok = ({ props, form }: modal_type) => {

        const formatMessage = props?.intl?.formatMessage as IntlFormatters['formatMessage'];
        const form_value = form?.getFieldsValue();
        const { set_table_list, lang, content_sidebar_selected, action, item_selected, cron_text, service_name, selected_config, instance_item_selected, instance_list } = props;
        let action_id = props?.action_id, caption = props?.custom_caption; let data; let selected_instance_id;
        if (action === 0 && action_id !== 4) caption = 'create';
        switch (content_sidebar_selected) {
            case "backup_management":
                if (action_id === 3) {
                    caption = 'restore';
                    selected_instance_id = instance_list?.filter(({ instance_name }: any) => { return instance_name === form_value?.instance_name })?.[0]?.instance_id;
                }
                break;
            case "backup_configuration":
                // if (action_id === 1) caption = 'backup';
                if (action_id === 2) caption = "edit_config";
                break;
            case "restore_management":
                if (action_id === 3) caption = "stop_restore";
                break;
            case "backup_schedule":
                if (action_id === 1) caption = "edit_backup_schedule";
                if (action_id === 3) caption = "enable";
                if (action_id === 4) caption = "disable";
                break;
            default:
                break;
        }

        if (form_value) {

            const create_body: Object = content_sidebar_selected !== "backup_schedule" ?
                content_sidebar_selected === "backup_management" ?
                    caption === "restore" ?
                        {
                            selectedDatabase: form_value.source_database,
                            newDatabaseName: form_value.source_database === "" ? "" : form_value.new_database_name,
                            description: form_value.description,
                            dbBackupId: item_selected.db_backup_id,
                            overwrite: {
                                instanceId: selected_instance_id === instance_item_selected?.instanceId ? "" : selected_instance_id
                            }
                        } :
                        {
                            // backup_config: form_value.backup_config,
                            // dbBackupName: form_value.backup_name,
                            expiryDays: form_value.expiry_days || selected_config?.manifest?.expiry_days,
                            description: form_value.description || selected_config?.manifest?.description,
                            backupType: form_value.backup_type || selected_config?.backup_type,
                            selectedDatabase: selected_config ?
                                selected_config?.selected_database
                                : (form_value.selected_database === "" ? "" : form_value.selected_database_list),
                            instanceId: instance_item_selected?.instanceId,
                            dbStorageId: form_value.backup_destination_storage || selected_config?.manifest?.db_storage?.id,
                            advanced: service_name === "InfluxDB" ? {
                                start: form_value.start_time?.utc().format() || selected_config?.manifest?.advanced?.start,
                                end: form_value.end_time?.utc().format() || selected_config?.manifest?.advanced?.end,
                                shard: form_value.shard || selected_config?.manifest?.advanced?.shard,
                                retention: form_value.retention || selected_config?.manifest?.advanced?.retention,
                                force: true
                            } : undefined
                            // period: form_value.period ? [form_value.period[0].format(), form_value.period[1].format('YYYY/MM/DD HH:mm:ss')] : []
                        } : {
                        // content_sidebar_selected === "backup_configuration"
                        dbBackupConfigName: form_value.configuration_name,
                        manifest: {
                            instanceId: instance_item_selected?.instanceId,
                            dbStorageId: form_value.backup_destination_storage,
                            selectedDatabase: form_value.selected_database === "" ? "" : form_value.selected_database_list,
                            expiryDays: form_value.expiry_days,
                            description: form_value.description,
                            backupType: form_value.backup_type,
                            // backupType: form_value.selected_database ? "Incremental" : "Full",
                            advanced: service_name === "InfluxDB" ? {
                                start: form_value.start_time?.utc().format(),
                                end: form_value.end_time?.utc().format(),
                                shard: form_value.shard,
                                retention: form_value.retention,
                                force: true
                            } : undefined
                        }
                    } : {
                    dbScheduleName: form_value.schedule_name,
                    frequency: form_value.frequency,
                    dbBackupConfigId: form_value.backup_configuration,
                    // dbBackupConfigId: (form_value.backup_configuration === backup_config_list?.[0]?.db_backup_config?.name || action_id === 1) ? backup_config_list?.[0].db_backup_config?.id : form_value.backup_configuration,
                    schedule: cron_text
                    // timeDescription: cron_text
                };

            // console.log("create_body ", create_body);

            switch (caption) {
                // 三个模块涉及 create ，需根据 content_sidebar_selected 进行区别不同 url
                case "create":
                    switch (props?.content_sidebar_selected) {
                        case "backup_management":
                            data = {
                                key: 'immediate_backup',
                                url: `/backup/dbBackups`,
                                body: create_body
                            };
                            set_table_list && set_name("status", "", set_table_list);
                            break;
                        case "backup_configuration":
                            data = {
                                key: 'lowercase_backup_configuration',
                                url: `/backup/dbBackupConfigs`,
                                body: create_body
                            };
                            break;
                        case "backup_schedule":
                            data = {
                                key: 'lowercase_backup_schedule',
                                url: '/backup/dbSchedules',
                                body: create_body
                            };
                            break;
                        default:
                            break;
                    }
                    break;
                case "restore":
                    data = {
                        key: 'restore',
                        url: "/backup/dbRestores",
                        body: create_body
                    };
                    break;
                // 开始备份
                // case "backup":
                //     data = {
                //         key: 'backup',
                //         url: ``
                //     };
                //     break;
                case "edit_config":
                    data = {
                        key: 'backup_configuration',
                        url: `/backup/dbBackupConfigs/${item_selected?.db_backup_config.id}`,
                        body: create_body,
                        patch: 1,
                        content_type: "application/merge-patch+json",
                        custom_warning: (e: any) => {
                            custom_warning({
                                response_new: e as response_type,
                                key: "backup_configuration",
                                formatMessage,
                                success_message: `${formatMessage({ id: 'lowercase_backup_configuration' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'updated' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'successfully' })}`,
                                error_message: `${formatMessage({ id: 'lowercase_backup_configuration' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'updated' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'error' })}`
                            })
                        }
                    };
                    break;
                case "edit_backup_schedule":
                    data = {
                        key: "backup_schedule",
                        url: `/backup/dbSchedules/${item_selected.db_schedule?.id}`,
                        body: create_body,
                        patch: 1,
                        content_type: "application/merge-patch+json",
                        custom_warning: (e: any) => {
                            custom_warning({
                                response_new: e as response_type,
                                key: "backup_schedule",
                                formatMessage,
                                success_message: `${formatMessage({ id: 'lowercase_backup_schedule' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'updated' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'successfully' })}`,
                                error_message: `${formatMessage({ id: 'lowercase_backup_schedule' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'updated' })}${lang === "en-US" ? " " : ""}${formatMessage({ id: 'error' })}`
                            })
                        }
                    };
                    break;
                case "enable":
                    data = {
                        key: "lowercase_backup_schedule",
                        url: `/backup/dbSchedules/${item_selected.db_schedule?.id}/enable`
                    };
                    break;
                case "disable":
                    data = {
                        key: "lowercase_backup_schedule",
                        url: `/backup/dbSchedules/${item_selected.db_schedule?.id}/disable`
                    };
                    break;
                default:
                    data = {
                        url: ``
                    };
                    break;
            }
        } else {
            data = { url: '' };
        }
        return data;
    };

    const immediate_backup_msg = ({ props, form, formatMessage, set_disabled }: modal_type) => {

        const { items,
            action,
            instance_datasource,
            instance_name,
            service_name,
            content_sidebar_selected,
            action_id,
            storage_list,
            backup_config_list,
            db_list,
            item_selected,
            selected_config,
            instance_item_selected,
            set_selected_config
            // start_time,
            // set_start_time
        } = props;
        const is_backup_configuration: boolean = content_sidebar_selected === "backup_configuration";
        let caption = props?.custom_caption;
        if (is_backup_configuration) {
            caption = action_id === 2 ? "edit_config" : action_id === 0 ? "add_config" : undefined;
        }
        const selected_database: string = form?.getFieldValue("selected_database");
        const backup_config: string = form?.getFieldValue("backup_config");

        // 备份目标存储数据列表
        let backup_destination_option: string = form?.getFieldValue("destination_storage_level1") ? form?.getFieldValue("destination_storage_level1") : storage_list?.[0]?.type;
        let backup_destination_detail: storage_detail[] | undefined = [];
        backup_destination_detail = storage_list?.filter(({ type }) => { return type === backup_destination_option })[0]?.db_storage;

        let storage_type: string = "";
        storage_list?.length && storage_list.map(item => {
            let storage_selected: storage_detail[] = [];
            storage_selected = item?.db_storage.filter(({ id }) => { return id === (item_selected || selected_config)?.manifest?.db_storage?.id });
            if (storage_selected.length) storage_type = item.type;
            return storage_type
        })

        let same_type_list: { type: string, db_storage: { id: string, name: string }[] } | undefined = undefined;
        same_type_list = storage_type && storage_list ? storage_list.filter(({ type }) => { return type === storage_type })[0] : undefined;

        // let start_time = form?.getFieldValue("start_time")?.utc().format();
        let start_time = form?.getFieldValue("start_time");
        let end_time = form?.getFieldValue("end_time");

        let initial_data: Object = {};
        initial_data = caption === "edit_config" ?
            {
                configuration_name: item_selected?.configuration_name,
                expiry_days: item_selected?.manifest.expiry_days,
                backup_type: item_selected?.backup_type,
                selected_database: item_selected?.selected_database === "" ? "" : "specify",
                selected_database_list: item_selected?.selected_database !== "" ? item_selected?.selected_database : undefined,
                destination_storage_level1: storage_type ? storage_type : undefined,
                backup_destination_storage: same_type_list?.db_storage?.length && same_type_list?.db_storage.filter(item => { return item?.id === item_selected?.manifest?.db_storage?.id }).length
                    ? item_selected?.manifest?.db_storage?.id : undefined,
                description: item_selected?.manifest?.description,
                start_time: item_selected?.manifest?.advanced?.start ? moment(get_time(item_selected?.manifest?.advanced?.start), "YYYY/MM/DD HH:mm:ss") : undefined,
                end_time: item_selected?.manifest?.advanced?.end ? moment(get_time(item_selected?.manifest?.advanced?.end), "YYYY/MM/DD HH:mm:ss") : undefined,
                // shard: item_selected?.manifest?.advanced?.shard,
                retention: item_selected?.manifest?.advanced?.retention
            } : {
                backup_config: "custom",
                expiry_days: 7,
                selected_database: "",
                backup_type: "Full",
                destination_storage_level1: backup_destination_option,
                backup_destination_storage: backup_destination_detail?.[0]?.id
            }

        if (service_name === "InfluxDB") {
            let time_picker_list: any = [];
            time_picker_list = document.getElementsByClassName("ant-picker-ok");
            for (let item of time_picker_list) {
                let picker = item?.getElementsByClassName("ant-btn-primary")[0]?.getElementsByTagName("span")[0];
                if (picker) {
                    picker.innerText = "OK";
                }
            }
        }

        const backup_config_params = [
            "backup_type",
            "selected_database",
            "expiry_days",
            "backup_destination_storage",
            "description",
            "advanced"
        ];

        return (
            <Fragment>
                <Form className="px-20" labelAlign='left' layout='vertical' form={form} initialValues={initial_data}>
                    {instance_datasource && Object.keys(instance_datasource).length && instance_name && service_name && <Form.Item label={formatMessage({ id: "instance_name" })} name="instance" rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]}>
                        <Input.Group compact>
                            <Form.Item style={{ width: '38%', marginBottom: "0" }} key="service_name" name="service_name">
                                <Select
                                    style={{ width: '100%' }}
                                    showSearch
                                    value={props.service_name}
                                    onChange={(event: string) => {
                                        props.set_service_name?.(event)
                                    }}
                                    placeholder={formatMessage({ id: "please_choose" })}
                                >
                                    {props?.service_list?.map((item: any) => {
                                        return (
                                            <Option value={item.name} key={item.name}>
                                                {item.name}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                            <Form.Item style={{ width: '60%', marginLeft: '2%', marginBottom: "0" }} key="instance" name="instance">
                                <Select
                                    style={{ width: '100%' }}
                                    showSearch
                                    disabled={!(props.instance_datasource[props.service_name])?.length}
                                    value={props.instance_name}
                                    onChange={(event: string) => {
                                        props.set_instance_name?.(event)
                                    }}
                                    placeholder={formatMessage({ id: "no_instances" })}>
                                    {props.instance_datasource[props.service_name]?.map((item: any) => {
                                        return (
                                            <Option value={item} key={item}>
                                                {item}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>}
                    {props.instance_name !== "All" && <Fragment>
                        {(instance_item_selected?.service === "MongoDB" || instance_item_selected?.service === "PostgreSQL") && <Alert
                            className="restore_alert backup-alert"
                            message={formatMessage({ id: "backup_warn" })}
                            type="warning"
                            showIcon />}
                        {!is_backup_configuration ?
                            <Fragment>
                                <Form.Item
                                    label={formatMessage({ id: "backup_configuration" })}
                                    key="backup_config"
                                    name="backup_config"
                                    style={{ marginBottom: "20px" }}
                                    rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]}>
                                    <Radio.Group
                                        onChange={(e: any) => {
                                            e.target.value === "custom" && set_selected_config?.(undefined);
                                            form?.setFieldsValue({ selected_config: undefined });
                                            on_change(form, set_disabled);
                                        }}>
                                        <Radio style={{ display: 'block' }} value="custom">
                                            {formatMessage({ id: "custom_config" })}
                                        </Radio>
                                        <Radio style={{ display: 'block' }} value="existing">
                                            {formatMessage({ id: "backup_config_desc" })}
                                        </Radio>
                                    </Radio.Group>
                                </Form.Item>
                                {backup_config === "existing" && <Form.Item
                                    style={{ marginTop: "-15px" }}
                                    key="selected_config"
                                    name="selected_config"
                                    rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]}>
                                    <Select
                                        placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "backup_configuration" }).toLowerCase()}` })}
                                        onChange={(e: any) => {
                                            let change_item: item_type | undefined = backup_config_list?.filter(({ configuration_name }) => { return configuration_name === e })?.[0];
                                            set_selected_config?.(change_item);
                                            on_change(form, set_disabled);
                                        }}>
                                        {backup_config_list?.map(({ db_backup_config }) => (
                                            <Option key={db_backup_config?.id} value={db_backup_config?.name as string}>{db_backup_config?.name}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>}
                            </Fragment> :
                            <Form.Item label={formatMessage({ id: "configuration_name" })} key="configuration_name" name="configuration_name"
                                rules={[
                                    { required: true, message: formatMessage({ id: "this_is_required" }) },
                                    { type: "string", max: 253, message: formatMessage({ id: "max_name_length" }, { length: 253 }) },
                                    { pattern: /^\S+$/, message: formatMessage({ id: "backup_regexp_3" }) },
                                    check_existed(formatMessage, items, action, item_selected)
                                ]}>
                                <Input
                                    placeholder={formatMessage({ id: "please_input" }, { type: `${formatMessage({ id: "configuration_name" }).toLowerCase()}` })}
                                    onKeyDown={(event: any) => {
                                        if (event.keyCode === 13) event.target.blur();
                                    }}
                                    onChange={() => {
                                        on_change(form, set_disabled);
                                    }} />
                            </Form.Item>}
                        {!selected_config ?
                            backup_config === "existing" ? undefined :
                                <Fragment>
                                    <Form.Item label={formatMessage({ id: "expiry_days" })} key="expiry_days" name="expiry_days"
                                        rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]}>
                                        <InputNumber style={{ width: 200 }} min={1} onChange={e => {
                                            on_change(form, set_disabled);
                                        }} />
                                    </Form.Item>
                                    <Form.Item className="flex_row_center"
                                        label={formatMessage({ id: "backup_type" })}
                                        key="backup_type" name="backup_type"
                                        style={{ marginBottom: "20px" }}
                                        rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]}>
                                        <Radio value="Full" defaultChecked>{formatMessage({ id: "full_backup" })}</Radio>
                                    </Form.Item>
                                    <Form.Item
                                        label={formatMessage({ id: "select_database_backup" })}
                                        key="selected_database"
                                        name="selected_database"
                                        style={{ marginBottom: "20px" }}>
                                        <Radio.Group
                                            onChange={(e: any) => {
                                                on_change(form, set_disabled);
                                            }}>
                                            <Radio style={{ display: 'block', height: '28px' }} value="">
                                                {formatMessage({ id: "backup_type_full" })}
                                            </Radio>
                                            <Radio style={{ display: 'block', height: '28px' }} value="specify">
                                                {formatMessage({ id: "backup_type_individual" })}
                                            </Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                    {selected_database === "specify" && <Form.Item style={{ marginTop: "-15px" }}
                                        key="selected_database_list"
                                        name="selected_database_list"
                                        className="muti-select"
                                        rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]}>
                                        <Select
                                            allowClear
                                            showSearch
                                            style={{ width: '100%' }}
                                            placeholder={formatMessage({ id: "backup_type_individual_desc" })}
                                            onChange={(e: any) => {
                                                on_change(form, set_disabled);
                                            }}
                                        >
                                            {db_list?.resources_list?.length && [db_list?.resources_list.map((item: any) => (
                                                <Option key={item} value={item}>{item}</Option>
                                            ))]}
                                        </Select>
                                    </Form.Item>}
                                    <Form.Item
                                        name="backup_destination_storage"
                                        label={formatMessage({ id: "destination_storage" })}
                                        rules={[{ required: true, message: formatMessage({ id: "destination_storage_validate" }) }]}>
                                        <Input.Group compact style={{ height: "32px" }}>
                                            <Form.Item style={{ width: '40%', marginBottom: "0" }} key="destination_storage_level1" name="destination_storage_level1">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    disabled={!storage_list?.length}
                                                    placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "storage_type" }).toLowerCase()}` })}
                                                    onChange={(event: any) => {
                                                        on_change(form, set_disabled);
                                                        form?.setFieldsValue({ backup_destination_storage: (storage_list?.filter(item => { return item.type === event })[0]?.db_storage[0]?.id) })
                                                    }}
                                                >
                                                    {storage_list?.map(data => (
                                                        <Option key={data.type} value={data.type}>{data.type === "nfs" ? "NFS" : data.type}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                            <Form.Item style={{ width: '40%', marginLeft: '2%', marginBottom: "0" }} key="backup_destination_storage" name="backup_destination_storage">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    disabled={!storage_list?.length}
                                                    placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "backup_destination_storage" }).toLowerCase()}` })}
                                                    onChange={(e: any) => {
                                                        on_change(form, set_disabled);
                                                    }}>
                                                    {backup_destination_detail?.map(cell => (
                                                        <Option key={cell.id} value={cell.id}>{cell.name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                            <Form.Item style={{ marginBottom: "0" }}>
                                                <PlusCircleFilled
                                                    onClick={() => { go_storageSettings_confirm(props, formatMessage, "storage_settings") }}
                                                    className="plus-destination pointer ml-10" />
                                            </Form.Item>
                                        </Input.Group>
                                    </Form.Item>
                                    <Form.Item
                                        label={formatMessage({ id: "description" })}
                                        key="description" name="description">
                                        <Input
                                            onKeyDown={(event: any) => {
                                                if (event.keyCode === 13) event.target.blur();
                                            }}
                                            onChange={(e: any) => {
                                                on_change(form, set_disabled);
                                            }}
                                            placeholder={formatMessage({ id: "edit_description_placeholder" })} />
                                    </Form.Item>
                                    {service_name === "InfluxDB" && <Col className="backup-collapse">
                                        <Collapse defaultActiveKey={['1']} style={{ marginTop: "15px" }}>
                                            <Panel header={formatMessage({ id: "advanced" })} key="1">
                                                <Form.Item
                                                    style={{ marginBottom: "0" }}
                                                    label={formatMessage({ id: "backup_period" })}>
                                                    <Input.Group compact>
                                                        <Form.Item
                                                            style={{ width: '45%', marginRight: "3%" }}
                                                            rules={[
                                                                {
                                                                    validator(_rule: any, value: string) {
                                                                        return new Date(get_time(start_time)).getTime() - new Date(get_time(end_time)).getTime() > 0
                                                                            ? Promise.reject(formatMessage({ id: 'time_warn' }))
                                                                            : Promise.resolve();
                                                                    }
                                                                }
                                                            ]}
                                                            key="start_time"
                                                            name="start_time">
                                                            <DatePicker
                                                                placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "cron_start_time" }).toLowerCase()}` })}
                                                                style={{ width: '100%' }}
                                                                format="YYYY/MM/DD HH:mm:ss"
                                                                showTime
                                                                showNow={false}
                                                                onChange={(e: any) => {
                                                                    form?.setFieldsValue({ end_time: moment() });
                                                                    on_change(form, set_disabled);
                                                                }}
                                                            />
                                                            {/* <RangePicker
                                                    style={{ width: '100%' }}
                                                    placeholder={[formatMessage({ id: "start_time" }), formatMessage({ id: "end_time" })]}
                                                    showTime
                                                    format="YYYY/MM/DD HH:mm:ss"
                                                    onChange={(e: any) => {
                                                        on_change(form, set_disabled);
                                                    }}
                                                /> */}
                                                        </Form.Item>
                                                        <Col className="time-line"></Col>
                                                        <Form.Item style={{ width: '45%', marginLeft: "3%" }} key="end_time" name="end_time">
                                                            <DatePicker
                                                                showNow={false}
                                                                placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "cron_end_time" }).toLowerCase()}` })}
                                                                style={{ width: '100%' }}
                                                                format="YYYY/MM/DD HH:mm:ss"
                                                                showTime
                                                                disabledDate={(current) => {
                                                                    return current && current < form?.getFieldValue("start_time");
                                                                }}
                                                                onChange={(e: any) => {
                                                                    on_change(form, set_disabled);
                                                                }}
                                                            />
                                                        </Form.Item>
                                                    </Input.Group>
                                                </Form.Item>
                                                {!(!selected_database && instance_item_selected?.service === "InfluxDB") && <Form.Item style={{ marginBottom: "0" }}>
                                                    <Input.Group compact>
                                                        {/* <Form.Item label={formatMessage({ id: "shard" })} style={{ width: '46%' }} key="shard" name="shard">
                                                            <Input
                                                                style={{ width: '100%' }}
                                                                placeholder={formatMessage({ id: "please_input" }, { type: `${formatMessage({ id: "shard_id" })}` })}
                                                                onKeyDown={(event: any) => {
                                                                    if (event.keyCode === 13) event.target.blur();
                                                                }}
                                                                onChange={(e: any) => {
                                                                    on_change(form, set_disabled);
                                                                }}
                                                            />
                                                        </Form.Item> */}
                                                        <Form.Item label={formatMessage({ id: "retention" })} style={{ width: '45%' }} key="retention" name="retention">
                                                            <Input
                                                                style={{ width: '100%' }}
                                                                placeholder={formatMessage({ id: "please_input" }, { type: `${formatMessage({ id: "retention_placeholder" }).toLowerCase()}` })}
                                                                onKeyDown={(event: any) => {
                                                                    if (event.keyCode === 13) event.target.blur();
                                                                }}
                                                                onChange={(e: any) => {
                                                                    on_change(form, set_disabled);
                                                                }} />
                                                        </Form.Item>
                                                    </Input.Group>
                                                </Form.Item>}
                                            </Panel>
                                        </Collapse>
                                    </Col>}
                                </Fragment>
                            : <Col className="backup-description mb-20">
                                <Descriptions bordered size="small" column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}>
                                    {(service_name === "InfluxDB" && Object.keys(Object(selected_config)?.manifest?.advanced).length
                                        ? backup_config_params :
                                        backup_config_params.slice(0, backup_config_params.length - 1)).map(cell =>
                                            <Descriptions.Item
                                                labelStyle={{ width: 200 }}
                                                label={<span title={formatMessage({ id: cell })}>{formatMessage({ id: cell })}</span>}
                                            >
                                                {(cell === "expiry_days" || cell === "description") ?
                                                    selected_config?.manifest?.[cell] :
                                                    cell === "advanced" ? JSON.stringify(selected_config?.manifest?.advanced) :
                                                        cell === "selected_database" ? selected_config?.selected_database || formatMessage({ id: "all_databases" }) :
                                                            cell === "backup_type" ? formatMessage({ id: selected_config?.backup_type }) :
                                                                (selected_config as any)?.[cell]}
                                            </Descriptions.Item>
                                        )}
                                </Descriptions>
                            </Col>}
                        {/* {!is_backup_configuration && <Form.Item className="mt--9 mb-0" name="save_settings" key="save_settings" valuePropName="checked">
                    <Checkbox>{formatMessage({ id: "save_settings" })}</Checkbox>
                  </Form.Item>} */}
                    </Fragment>}
                </Form>
            </Fragment>
        )
    };

    const details_msg = ({ props, formatMessage }: modal_type) => {

        const { content_sidebar_selected, item_selected, set_view_log, view_log, service_name } = props;
        const is_backup: boolean = content_sidebar_selected === "backup_management" ? true : false;

        item_selected && (async () => {
            (await fetch(`/backup/${is_backup ? `dbBackups/${item_selected.db_backup_id}` : `dbRestores/${item_selected.db_restore_id}`}/log`)).text().then(data => {
                set_view_log?.(data);
            });
        })();

        const backup_details_params = [
            {
                title: "basic_information",
                label_list: [
                    // "backup_name",
                    "service_name",
                    "status",
                    "backup_type",
                    "selected_database",
                    // "backup_size",
                    "expiry_time",
                    "description"
                ]
            },
            {
                title: "advanced_information",
                label_list: service_name === "InfluxDB" && item_selected?.advanced && Object.keys(item_selected.advanced).length ? [
                    "start_time",
                    "end_time",
                    "backup_duration",
                    "trigger_mode",
                    "storage_type",
                    "storage_name",
                    "advanced"
                ] : [
                        "start_time",
                        "end_time",
                        "backup_duration",
                        "trigger_mode",
                        "storage_type",
                        "storage_name"
                    ]
            }
        ];
        const restore_details_params = [
            {
                title: "restore_information",
                label_list: [
                    // "backup_name",
                    "service_name",
                    "backup_id",
                    "status",
                    "selected_database",
                    // "restore_policy",
                    "new_database_name",
                    "restore_start_time",
                    "restore_end_time",
                    "restore_duration",
                    "description"
                ]
            }
        ];

        return (
            <Col className="px-10 backup-details-cell backup-description">
                { (content_sidebar_selected === "restore_management" ? restore_details_params : backup_details_params).map((item, index) => <Col className="mb-25">
                    <Row className="backup-management-label font-w-6">
                        {formatMessage({ id: item.title })}
                    </Row>
                    <Descriptions bordered size="small" column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                        {item.label_list.map(cell =>
                            <Descriptions.Item
                                // labelStyle={{ width: "200px" }}
                                span={cell === "backup_name" ? 3 : undefined}
                                label={<span style={{ whiteSpace: "pre" }} title={formatMessage({ id: cell })}>{formatMessage({ id: cell })}</span>}
                            >
                                {cell === "status" ?
                                    <Tag style={{ opacity: '0.8' }} color={backup_status[(item_selected?.[cell] || "Pending")?.toLocaleLowerCase()]}>
                                        {item_selected?.[cell] || "Pending"}
                                    </Tag> :
                                    cell.includes("time") ? <Row style={{ whiteSpace: "pre" }}>
                                        {item_selected?.[cell]?.includes("0001") ? "--/--/---- --:--:--" : get_time(item_selected?.[cell])}
                                    </Row> :
                                        // cell === "description" ? edit_description ?
                                        //     <TextArea
                                        //         // value={description}
                                        //         autoSize={{ minRows: 1, maxRows: 3 }}
                                        //         placeholder={formatMessage({ id: "edit_description_placeholder" })}
                                        //         onChange={(e: any) => { set_description?.(e.target.value) }} /> :
                                        //     !description ?
                                        //         <EditOutlined
                                        //             className="icon-color ml-5 pointer"
                                        //             onClick={() => { set_edit_description?.(true) }}
                                        //         /> : description :
                                        cell === "backup_size" ? <Fragment>
                                            {props?.item_selected[cell]}
                                            <DownloadOutlined
                                                className="icon-color ml-5 pointer"
                                                onClick={() => {
                                                    download_file(item_selected?.backup_name);
                                                }} />
                                        </Fragment> :
                                            cell === "advanced" ? JSON.stringify(item_selected[cell]) :
                                                cell === "selected_database" ? item_selected?.[cell] ?
                                                    <Row className="table-caption w-300 text-ellipsis" title={item_selected?.[cell]}>
                                                        {item_selected?.[cell]}
                                                    </Row> :
                                                    formatMessage({ id: "all_databases" }) :
                                                    cell === "storage_type" ? item_selected?.[cell] === "nfs" ? "NFS" : item_selected?.[cell] :
                                                        cell === "backup_type" && item_selected?.[cell] === "Full" ? formatMessage({ id: "Full" }) :
                                                            cell === "trigger_mode" ? formatMessage({
                                                                id: item_selected?.[cell] === "Scheduler" ? "schedule" : "manual"
                                                            }) :
                                                                (cell === "storage_name" || cell === "description") ? <Row className="table-caption w-300 text-ellipsis" title={item_selected?.[cell]}>{item_selected?.[cell]}</Row> :
                                                                    cell === "backup_id" ? <Col
                                                                        className={`${!item_selected?.[cell] ? "is_deleted" : "w-270 d-inline align-middle"}`}>
                                                                        {item_selected?.[cell] || formatMessage({ id: "is_deleted" })}
                                                                    </Col> :
                                                                        item_selected?.[cell]}
                            </Descriptions.Item>
                        )}
                    </Descriptions>
                </Col>)
                }

                <Collapse>
                    <Panel header={formatMessage({ id: "view_log" })} className="view-log" key="1">
                        <TextArea
                            value={view_log ? view_log : formatMessage({ id: "no_log" })}
                            autoSize={{ minRows: 6, maxRows: 10 }} />
                    </Panel>
                </Collapse>
            </Col>
        );
    };

    const restore_msg = ({ props, form, formatMessage, set_disabled }: modal_type) => {

        const { restore_db_list, item_selected, instance_list, set_instance_list, instance_item_selected, format_subscriptions, service_name, datacenter_name } = props;
        let restore_all = form?.getFieldValue("source_database") === "";
        restore_all && set_disabled(false);

        return (
            <Col>
                <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} className="px-20" labelAlign='left' form={form}
                    initialValues={{
                        source_database: item_selected?.selected_database,
                        subscription_name: item_selected?.subscription_id,
                        instance_name: instance_item_selected?.instanceName
                    }}>
                    {/* <Form.Item key="policy" name="policy">
                        <Radio.Group
                            onChange={(e: any) => {
                                on_change(form, set_disabled);
                            }}>
                            <Radio style={{ display: 'block', height: '28px' }} value={0}>
                                {formatMessage({ id: "overwriting_database" })}
                                <Tooltip placement="right" title={formatMessage({ id: 'overwriting_database' })}>
                                    <QuestionCircleOutlined className="question-circle ml-5" />
                                </Tooltip>
                            </Radio>
                            <Radio style={{ display: 'block', height: '28px' }} value={1}>
                                {formatMessage({ id: "creating_database" })}
                            </Radio>
                        </Radio.Group>
                    </Form.Item> */}
                    <Form.Item label={formatMessage({ id: "source_database" })} key="source_database" name="source_database">
                        <Select
                            allowClear
                            showSearch
                            disabled={!item_selected?.selected_database ? undefined : true}
                            placeholder={formatMessage({ id: "backup_type_individual_desc" })}
                            onChange={(e: any) => {
                                on_change(form, set_disabled);
                            }}>
                            <Option key="" value="">{formatMessage({ id: "all_databases" })}</Option>
                            {restore_db_list?.length && restore_db_list.map((item: any) => (
                                <Option key={item} value={item}>{item}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {!form?.getFieldValue("source_database") ? <Alert
                        className="restore_alert"
                        message={formatMessage({ id: "source_all_warn" })}
                        type="warning"
                        showIcon /> :
                        <Alert
                            className="restore_alert"
                            message={formatMessage({ id: "restore_error_warn" })}
                            type="warning"
                            showIcon />}
                    <Col className="backup-collapse">
                        <Collapse defaultActiveKey={['1']} style={{ marginTop: "15px" }}>
                            <Panel header={formatMessage({ id: "specify_destination" })} key="1">
                                <Form.Item label={formatMessage({ id: "subscription_name" })} key="subscription_name" name="subscription_name" rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]}>
                                    <Select
                                        showSearch
                                        placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "subscription" }).toLowerCase()}` })}
                                        disabled={(format_subscriptions && format_subscriptions.length < 2)}
                                        optionFilterProp="children"
                                        dropdownRender={(menu) => (
                                            <Fragment>
                                                <div className="ant-select-item ant-select-item-group">With Resources Only</div>
                                                {menu}
                                            </Fragment>
                                        )}
                                        filterOption={(input, option) => (option?.key as string)?.toLocaleLowerCase().includes(input.toLocaleLowerCase())}
                                        style={{ width: '100%' }}
                                        onChange={(e: any) => {
                                            on_change(form, set_disabled);
                                            (async () => {
                                                let list: any = [];
                                                let instance_datasource: any[] | undefined = (await http_get(`/serviceHub/v2/subscriptions/${e}/serviceInstances?serviceName=${service_name}&datacenterCode=${datacenter_name}`, props) as any)?.data?.services;
                                                instance_datasource?.map((val: any, key: any) => {
                                                    const {
                                                        serviceInstanceId,
                                                        serviceInstanceName,
                                                        subscriptionId,
                                                        transactionId,
                                                        serviceCategory,
                                                        userId,
                                                        serviceName,
                                                        datacenterCode,
                                                        servicePlanName,
                                                        createdAt,
                                                        dashboardUrl,
                                                        bindable,
                                                        subscriptionCompany,
                                                        subscriptionName,
                                                        lifecycleStatus,
                                                        userProvided
                                                    } = val;
                                                    lifecycleStatus?.toLowerCase() !== 'none' && list.push({
                                                        key: key,
                                                        instance_id: serviceInstanceId,
                                                        instance_name: serviceInstanceName,
                                                        subscriptionId: subscriptionId,
                                                        transactionId: transactionId,
                                                        serviceCategory: serviceCategory,
                                                        userId: userId,
                                                        service_name: serviceName,
                                                        datacenterCode: datacenterCode,
                                                        plan: servicePlanName,
                                                        status: lifecycleStatus,
                                                        creation_time_mp: format_time(createdAt),
                                                        dashboard_url: dashboardUrl,
                                                        bindable: bindable,
                                                        company: subscriptionCompany,
                                                        subscription_name: subscriptionName,
                                                        user_provided: userProvided
                                                    });
                                                    return list
                                                });
                                                set_instance_list?.(list);
                                                form?.setFieldsValue({
                                                    instance_name: list?.filter((item: any) => { return item?.user_provided === "false" && item?.plan !== "Shared" })?.[0]?.instance_name
                                                });
                                                on_change(form, set_disabled);
                                            })()
                                        }}
                                    >
                                        {Array.isArray(format_subscriptions) &&
                                            format_subscriptions.map(({ id, name, company }: any) => (
                                                <Option key={name + company} value={id}>
                                                    <Row
                                                        title={
                                                            formatMessage({ id: "subscription_name" }) +
                                                            ": " +
                                                            name +
                                                            "        " +
                                                            formatMessage({ id: "company" }) +
                                                            ": " +
                                                            company
                                                        }
                                                    >
                                                        <Col lg={9} md={10} sm={11} xs={12} className="font-w-6 text-ellipsis">
                                                            {name}
                                                        </Col>
                                                        <Col lg={13} md={12} sm={11} xs={10} className="ml-10 text-ellipsis">
                                                            {company}
                                                        </Col>
                                                    </Row>
                                                </Option>
                                            ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item label={formatMessage({ id: "instance_name" })} key="instance_name" name="instance_name"
                                    rules={[{ required: true, message: formatMessage({ id: "this_is_required" }) }]}>
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "instance_name" }).toLowerCase()}` })}
                                        onChange={(e: any) => {
                                            on_change(form, set_disabled);
                                        }}>
                                        {instance_list?.length && instance_list.filter(({ user_provided, plan }) => { return user_provided === "false" && plan !== "Shared" }).map(({ instance_name }) => (
                                            <Option key={instance_name} value={instance_name}>{instance_name}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                {!restore_all && <Form.Item label={formatMessage({ id: "new_database_name" })}
                                    rules={[
                                        { required: true, message: formatMessage({ id: "this_is_required" }) },
                                        { pattern: /^[a-zA-Z0-9]{1,}[a-zA-Z0-9-]{0,}$/, message: formatMessage({ id: "backup_regexp_1" }) },
                                        { type: "string", max: 63, message: formatMessage({ id: "max_name_length" }, { length: 63 }) }
                                    ]}
                                    // {
                                    //     validator(_rule: any, value: string) {
                                    //         return value?.length > 0 && db_list?.resources_list.find((item: string) => item === value)
                                    //             ? Promise.reject(formatMessage({ id: 'this_name_has_been_existed' }))
                                    //             : Promise.resolve();
                                    //     }}
                                    // check_existed(formatMessage, items)
                                    key="new_database_name"
                                    name="new_database_name">
                                    <Input
                                        placeholder={formatMessage({ id: "please_input" }, { type: `${formatMessage({ id: "new_database_name" }).toLowerCase()}` })}
                                        onKeyDown={(event: any) => {
                                            if (event.keyCode === 13) event.target.blur();
                                        }}
                                        onChange={(e: any) => {
                                            on_change(form, set_disabled);
                                        }} />
                                </Form.Item>}
                                <Form.Item label={formatMessage({ id: "description" })} key="description" name="description">
                                    <Input
                                        onKeyDown={(event: any) => {
                                            if (event.keyCode === 13) event.target.blur();
                                        }}
                                        placeholder={formatMessage({ id: "please_input" }, { type: `${formatMessage({ id: "description" }).toLowerCase()}` })}
                                        onChange={(e: any) => {
                                            on_change(form, set_disabled);
                                        }} />
                                </Form.Item>
                            </Panel>
                        </Collapse>
                    </Col>
                </Form>
                {/* <Row className="restore-note">
                    <p
                        dangerouslySetInnerHTML={{
                            __html: marked(formatMessage({ id: "restore_note" })),
                        }}
                    />
                </Row> */}
            </Col >
        )
    };

    const start_backup_msg = ({ props, formatMessage, form, set_disabled }: modal_type) => {

        const { item_selected, service_name } = props;
        const start_backup_params = [
            "backup_type",
            "selected_database",
            "backup_destination_storage",
            "expiry_days",
            "advanced",
            "description"
        ];
        let format_backup_params = service_name === "InfluxDB" && item_selected?.manifest?.advanced &&
            Object.keys(item_selected.manifest.advanced).length ?
            start_backup_params : start_backup_params.slice(0, 4).concat(start_backup_params.slice(5));

        return <Col className="px-20 backup-description mb-20">
            <Form labelAlign='left' layout='vertical' form={form} initialValues={{ start_backup_config: item_selected?.configuration_name }}>
                {/* <Form.Item label={formatMessage({ id: "backup_name" })} key="backup_name" name="backup_name" rules={[{ required: true, message: formatMessage({ id: "this_is_required" })}]}>
                    <Input
                        placeholder={formatMessage({ id: "please_input" }, { type: `${formatMessage({ id: "backup_name" }).toLowerCase()}` })}
                        onChange={() => {
                            on_change(form, set_disabled);
                        }} />
                </Form.Item> */}
                <Form.Item label={formatMessage({ id: "start_backup_with_configuration" })} key="start_backup_config" name="start_backup_config">
                    <Select
                        style={{ width: '100%' }}
                        disabled
                    ></Select>
                </Form.Item>
                <Row style={{ marginBottom: "8px", marginLeft: "12px" }}>{formatMessage({ id: "start_according_settings" })}</Row>
                <Descriptions bordered size="small" column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}>
                    {format_backup_params.map(cell =>
                        <Descriptions.Item
                            labelStyle={{ width: "35%" }}
                            label={<span>{formatMessage({ id: cell })}</span>}
                        >
                            {cell === "advanced" ? JSON.stringify(item_selected?.manifest[cell]) :
                                cell === "selected_database" ? item_selected?.manifest[cell] || formatMessage({ id: "all_databases" }) :
                                    (cell === "description" || cell === "expiry_days") ? item_selected?.manifest[cell] :
                                        cell === "backup_type" && item_selected?.backup_type === "Full" ? formatMessage({ id: "Full" }) :
                                            item_selected?.[cell]}
                        </Descriptions.Item>
                    )}
                </Descriptions>
            </Form>
        </Col>
    }

    // const stop_backup_msg = ({ props }: modal_type) => {
    //     return <Row style={{ fontSize: 18, fontWeight: 500, margin: 20 }}>
    //         <FormattedMessage
    //             id={`${props?.content_sidebar_selected === "backup_management" ? "stop_backup_msg" : "stop_restore_msg"}`}
    //             values={{
    //                 item: <Fragment>
    //                     &nbsp;<b>{props?.item_selected["backup_name"]}</b>&nbsp;
    //         </Fragment>
    //             }} />
    //     </Row>
    // };

    const delete_backup_management_msg = ({ props, formatMessage }: modal_type) => {

        const { content_sidebar_selected, item_selected, lang } = props;

        return <Col className="px-10 py-10">
            <Row align="middle" style={{ flexWrap: "nowrap" }}>
                <ExclamationCircleFilled className="warning-icon" />
                <Row>{formatMessage({ id: "delete_backup_restore_msg" }, {
                    type: <Col>
                        <span className={`${lang === "en-US" ? "ml-5" : ""}`}>
                            {formatMessage({ id: content_sidebar_selected === "restore_management" ? "restore_job" : "backup" }).toLowerCase()}&nbsp;
                            </span>
                        <b className={`${lang !== "en-US" ? "mr-5" : ""}`}>{item_selected?.db_restore_id || item_selected?.backup_id}</b>
                    </Col>
                })}
                </Row>
            </Row>
        </Col >
    }

    const delete_config_msg = ({ props }: modal_type) => {

        const { config_schedule_list, item_selected } = props;
        return <Col className="px-20 py-10">
            {!!config_schedule_list?.length && <Fragment>
                <Row align="middle" style={{ flexWrap: "nowrap" }}>
                    <ExclamationCircleFilled className="warning-icon" />
                    <Col><FormattedMessage id={config_schedule_list?.length > 1 ? "delete_remark_s" : "delete_remark"} /></Col>
                </Row>
                <Col className="mt-10 ml-40 mb-10">
                    {config_schedule_list.map((item, index) => (
                        <Col className="schedule-item" key={`schedule_${index}`}>{item.dbSchedule?.name}</Col>
                    ))}
                </Col>
            </Fragment>}
            <Row style={{ flexWrap: "nowrap" }} className={`${config_schedule_list?.length ? "ml-30" : ""}`}>
                {!config_schedule_list?.length ? <Fragment>
                    <ExclamationCircleFilled className="warning-icon" />
                    <Col>
                        <FormattedMessage id="confirm_delete_no_schedule" values={{
                            name: <Col
                                style={{ display: "contents", wordBreak: "break-all" }}
                            >
                                <span className="ml-5 mr-5 font-w-6">{item_selected?.configuration_name}</span>
                            </Col>
                        }} />
                    </Col>
                </Fragment> :
                    <FormattedMessage id="delete_warn" />
                }
            </Row>
        </Col>
    }

    const delete_schedule_msg = ({ props, formatMessage }: modal_type) => {

        const { enable_schedule_list, item_selected, lang } = props;

        return <Col className="px-10 py-10">
            <Row style={{ flexWrap: "nowrap" }}>
                <ExclamationCircleFilled className="warning-icon" />
                <Col>{formatMessage({ id: "delete_schedule_msg" }, {
                    name: <Col
                        style={{ display: "contents", wordBreak: "break-all" }}
                        className={`font-w-6 ml-5 ${lang !== "en-US" ? "mr-5" : ""}`}>
                        <span className="ml-5 mr-5 font-w-6">{item_selected?.name}</span>
                    </Col>
                })}
                </Col>
            </Row>
            {!!enable_schedule_list?.length &&
                <Row style={{ fontSize: "14px", marginTop: "15px", marginLeft: "25px" }}>
                    {formatMessage({ id: "schedule_warn" })}
                    {/* {formatMessage({ id: "schedule_warn" }, { item: <Col className="ml-5 mr-5 font-w-6">{enable_schedule_list?.[0]?.db_backup_id}</Col> })} */}
                </Row>}
        </Col>
    }

    const add_backup_schedule_msg = ({ props, form, formatMessage, set_disabled }: modal_type) => {

        // eslint-disable-next-line
        const { items, action, action_id, service_name, item_selected, backup_config_list, cron_text, set_cron_text, disabled_hours, monthOptions, month_selected_list, set_month_selected_list, month_item_status, set_month_item_status } = props;
        // const frequency: string = form?.getFieldValue("frequency");
        // let disabled_hours: boolean = false;

        // frequency 选项列表
        // const frequency_list: any[] = [
        //   { key: "0", value: "Once" },
        //   { key: "1", value: "Interval" },
        //   { key: "2", value: "Weekly" },
        //   { key: "3", value: "Monthly" }
        // ];
        let selected_config: any = {};
        selected_config = backup_config_list?.filter(item => {
            return item.db_backup_config?.id === form?.getFieldValue("backup_configuration")
        })[0];

        let time_picker_list: any = [];
        time_picker_list = document.getElementsByClassName("ant-picker-ok");
        for (let item of time_picker_list) {
            let picker = item?.getElementsByClassName("ant-btn-primary")[0]?.getElementsByTagName("span")[0];
            if (picker) {
                picker.innerText = "OK";
            }
        }

        const add_backup_schedule_params = [
            "backup_type",
            "selected_database",
            "backup_destination_storage",
            "expiry_days",
            "advanced",
            "description"
        ];

        const weeksOptions: string[] = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        let initial_data: Object = {};
        // Interval Day 大于 0, 禁用 Hours
        props.set_disabled_hours?.(form?.getFieldValue("backup_interval_days") > 0 ? true : false);
        // Weekly 和 Monthly 时的多选项列表
        let muti_list: any[] = [];
        switch (item_selected?.frequency) {
            case "Weekly":
                let week_list: any[] = item_selected?.cron_time.replace(/,/g, "").split(" ").slice(0, item_selected?.cron_time.split(" ").length - 1);
                week_list.map(item => {
                    return muti_list.push(...weeksOptions.filter(week => { return week.includes(item) }));
                });
                break;
            case "Monthly":
                muti_list = item_selected?.cron_time.replace(/,/g, "").split(" ").slice(0, item_selected?.cron_time.split(" ").length - 1);
                break;
            default:
                break;
        }

        initial_data = action_id === 0 ?
            {
                frequency: "hour",
                // cron: "* * * * *",
                backup_configuration: backup_config_list?.[0]?.db_backup_config?.id,
                // backup_once_time: moment(),
                // start_time: moment().startOf('day'),
                // backup_interval_days: 0,
                // backup_interval_hours: 1
            } :
            {
                schedule_name: item_selected?.schedule_name,
                frequency: item_selected?.frequency,
                // backup_once_time: item_selected?.frequency === "Once" && moment(item_selected?.cron_time, "YYYY/MM/DD HH:mm:ss"),
                // backup_interval_days: item_selected?.frequency === "Interval" && item_selected?.cron_time.includes("Day") && item_selected?.cron_time.split(" ")[1],
                // backup_interval_hours: item_selected?.frequency === "Interval" && item_selected?.cron_time.includes("Hour") && item_selected?.cron_time.split(" ")[1],
                // start_time: (item_selected?.frequency === "Weekly" || item_selected?.frequency === "Monthly") && moment(item_selected?.cron_time.split(" ")[item_selected?.cron_time.split(" ").length - 1], "HH:mm:ss"),
                // backup_start_week: muti_list,
                // backup_start_day: muti_list,item_selected?.db_backup_config?.id
                cron: item_selected?.cron_time,
                backup_configuration: backup_config_list?.filter(item => { return item?.db_backup_config?.id === item_selected?.db_backup_config?.id }).length
                    ? item_selected?.db_backup_config?.id : undefined,
                // backup_destination_storage: ,
            };

        return <Form
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            className="px-20 pr-30 backup-schedule backup-description"
            labelAlign='left'
            form={form}
            initialValues={initial_data}>
            <Form.Item label={formatMessage({ id: "schedule_name" })} key="schedule_name" name="schedule_name"
                rules={[
                    { required: true, message: formatMessage({ id: "this_is_required" }) },
                    { pattern: /^[a-zA-Z0-9]+([a-zA-Z0-9.-]{0,}[a-zA-Z0-9]+)?$/, message: formatMessage({ id: "backup_regexp_2" }) },
                    { type: "string", max: 63, message: formatMessage({ id: "max_name_length" }, { length: 63 }) },
                    check_existed(formatMessage, items, action, item_selected)
                ]}>
                <Input
                    style={{ width: '100%' }}
                    placeholder={formatMessage({ id: "please_input" }, { type: `${formatMessage({ id: "schedule_name" }).toLowerCase()}` })}
                    onKeyDown={(event: any) => {
                        if (event.keyCode === 13) event.target.blur();
                    }}
                    onChange={(e: any) => {
                        on_change(form, set_disabled);
                    }}
                />
            </Form.Item>
            {set_cron_text && <Cron
                cron_text={cron_text as string}
                set_cron_text={set_cron_text}
                item_selected={item_selected}
                set_disabled={set_disabled}
                form={form}
            />}
            <Form.Item
                name="backup_configuration"
                label={formatMessage({ id: "backup_configuration" })}
                rules={[{ required: true, message: formatMessage({ id: "backup_configuration_validate" }) }]}>
                <Input.Group compact>
                    <Form.Item style={{ width: "calc(70% + 10px)", marginBottom: "0" }} key="backup_configuration_name" name="backup_configuration" >
                        <Select
                            showSearch
                            disabled={!backup_config_list?.length}
                            placeholder={formatMessage({ id: "please_select" }, { type: `${formatMessage({ id: "backup_configuration" }).toLowerCase()}` })}
                            style={{ width: '100%' }}
                            onChange={(e: any) => {
                                on_change(form, set_disabled);
                            }}
                        >
                            {backup_config_list?.map(({ db_backup_config }) => {
                                return (
                                    <Option value={db_backup_config?.id as string} key={db_backup_config?.id}>
                                        {db_backup_config?.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </Form.Item>
                    <Form.Item style={{ marginBottom: "0" }}>
                        <PlusCircleFilled
                            onClick={() => { go_storageSettings_confirm(props, formatMessage, "backup_configuration") }}
                            className="plus-destination pointer ml-10" />
                    </Form.Item>
                </Input.Group>
            </Form.Item>
            {/* {action_id === 1 &&  */}
            {selected_config && Object.keys(selected_config).length && <Descriptions bordered size="small" style={{ width: "100%" }} column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}>
                {(service_name === "InfluxDB" && Object.keys(selected_config?.manifest?.advanced).length ? add_backup_schedule_params :
                    add_backup_schedule_params.slice(0, 4).concat(add_backup_schedule_params.slice(5))).map(cell =>
                        <Descriptions.Item
                            labelStyle={{ width: "35%" }}
                            label={<span>{formatMessage({ id: cell })}</span>}
                        >
                            {cell === "advanced" ? JSON.stringify(selected_config.manifest[cell]) :
                                (cell === "expiry_days" || cell === "description") ? selected_config.manifest[cell] :
                                    cell === "backup_type" && selected_config?.[cell] === "Full" ? formatMessage({ id: "Full" }) :
                                        cell === "selected_database" ? selected_config?.[cell] || formatMessage({ id: "all_databases" }) :
                                            selected_config[cell]}
                        </Descriptions.Item>
                    )}
            </Descriptions>}
            {/* } */}
        </Form >
    }

    const enable_backup_schedule_msg = ({ props, formatMessage }: modal_type) => {
        const { action_id, lang } = props;

        return <Row style={{ height: 40, fontSize: 14, flexWrap: "nowrap" }}>
            <ExclamationCircleFilled className="warning-icon" />
            <Col>
                <FormattedMessage id="enable_backup_schedule_msg" values={{
                    type: formatMessage({ id: action_id === 3 ? "enable" : "backup_disable" }).toLowerCase(),
                    item: <Col
                        style={{ display: "contents", wordBreak: "break-all" }}>
                        <span className={`font-w-6 ${lang !== "en-US" ? "mx-5" : ""}`}>{props?.item_selected?.schedule_name}</span>
                    </Col>
                }} />
            </Col>
        </Row>
    }

    return [
        {
            ...operation_status('immediate_backup', 0, 'create'),
            width: 785,
            modal_message: immediate_backup_msg,
            handle_ok: backup_handle_ok,
            refresh_url: backup_management_refresh_url,
            refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            refresh_post_process: () => backup_post_process,
            initial_action: ({ form, props, set_disabled }: modal_type) => {
                set_disabled(false);
                form?.resetFields();
                props.set_selected_config?.(undefined);
            },
            custom_action: ({ props }: modal_type) => {
                const { instance_item_selected, content_sidebar_selected, set_visible, set_action_id, set_action, set_loading, set_db_list } = props;
                (async () => {
                    if (content_sidebar_selected === "backup_management") {
                        set_loading?.(true);
                        let backup_list: any[] = (await http_request('backup', props, undefined, `/backup/dbBackups?instanceId=${instance_item_selected?.instanceId}`, 0) as any)?.items || [];
                        let restore_list: any[] = (await http_request('restore_management', props, undefined, `/backup/dbRestores?instanceId=${instance_item_selected?.instanceId}`, 0) as any)?.items || [];
                        let running_backup: any[] = backup_list?.filter(({ status }) => { return status === "Running" || status === "Pending" || !status });
                        let running_restore: any[] = restore_list?.filter(({ status }) => { return status === "Running" || status === "Pending" || !status });
                        set_loading?.(false);
                        if (!running_backup.length && !running_restore.length) {
                            set_action?.(0);
                            set_action_id?.(0);
                            set_visible?.(1);
                            // selectedDatabase 为 specify 时的数据库列表
                            const res_data: any = await http_get(`/serviceHub/v2/serviceInstances/${instance_item_selected?.instanceId}/resources`, props);
                            set_db_list?.(res_data?.data || {});
                        } else {
                            Modal.warning({
                                style: { top: "200px" },
                                width: 430,
                                title: props.intl.formatMessage({ id: "restore_warn_title" },
                                    { type: `${props.intl.formatMessage({ id: `${running_backup.length ? 'backup' : 'restore'}` })}` }),
                                content: props.intl.formatMessage({ id: "restore_warn_content" })
                            })
                        }
                    } else if (content_sidebar_selected === "backup_configuration") {
                        set_action?.(0);
                        set_action_id?.(0);
                        set_visible?.(1);
                        // selectedDatabase 为 specify 时的数据库列表
                        const res_data: any = await http_get(`/serviceHub/v2/serviceInstances/${instance_item_selected?.instanceId}/resources`, props);
                        set_db_list?.(res_data?.data || {});
                    } else {
                        set_action?.(0);
                        set_action_id?.(0);
                        set_visible?.(1);
                    }
                })();
            }
        },
        //?
        {
            ...delete_operation('batch_delete', 'backup_management'),
            handle_ok: ({ props }: modal_type) => {
                props.set_selectable?.(0);
                return {
                    // url: `/v1/${(props.item_selected as { name: string } | undefined)?.name}`
                    url: ''
                };
            }
        },
        {
            ...operation_status("backup_details", 1, "details"),
            width: 880,
            modal_message: details_msg,
            footer: ({ props }: modal_type) => {
                return <Button type="primary" onClick={() => { props.set_visible?.(undefined) }}>OK</Button>
            },
            initial_action: ({ props }) => {
                const { set_edit_description } = props;
                set_edit_description?.(false);
            }
        },
        //?
        // {
        //     ...operation_status('stop_backup', 1, 'stop_backup'),
        //     modal_message: stop_backup_msg,
        //     handle_ok: ({ props }: modal_type) => {
        //         return {
        //             url: ''
        //         };
        //     },
        //     initial_action: ({ set_disabled }: modal_type) => {
        //         set_disabled(false);
        //     }
        // },
        {
            ...operation_status('restore', 0, 'restore'),
            width: 600,
            modal_message: restore_msg,
            handle_ok: backup_handle_ok,
            custom_action: ({ props }: modal_type) => {
                const { instance_item_selected, set_restore_db_list, set_visible, set_action_id, set_action, set_loading, service_name, datacenter_name, item_selected, set_instance_list } = props;
                (async () => {
                    set_loading?.(true);
                    const backup_list: any[] = (await http_request('backup', props, undefined, `/backup/dbBackups?instanceId=${instance_item_selected?.instanceId}`, 0) as any)?.items;
                    const restore_list: any[] = (await http_request('restore_management', props, undefined, `/backup/dbRestores?instanceId=${instance_item_selected?.instanceId}`, 0) as any)?.items;
                    const running_backup: any[] = backup_list?.filter(({ status }) => { return status === "Running" || status === "Pending" || !status });
                    const running_restore: any[] = restore_list?.filter(({ status }) => { return status === "Running" || status === "Pending" || !status });
                    set_loading?.(false);
                    if (!running_backup?.length && !running_restore?.length) {
                        set_action?.(0);
                        set_action_id?.(3);
                        set_visible?.(1);

                        // 当备份单一数据库时，获取所选 backup 可还原数据库列表
                        if (!item_selected?.selected_database) {
                            let restore_list: string[] | undefined;
                            restore_list = (await http_request('get_availableDatabases',
                                props,
                                undefined,
                                `/backup/dbBackups/${item_selected?.backup_id}/availableDatabases`,
                                0) as any)?.available_databases;
                            restore_list && set_restore_db_list?.(restore_list);
                        } else {
                            set_restore_db_list?.([item_selected?.selected_database])
                        }
                        // 订阅号选单初始化
                        let list: any = [];
                        let instance_datasource: any[] | undefined = (await http_get(`/serviceHub/v2/subscriptions/${item_selected?.subscription_id}/serviceInstances?serviceName=${service_name}&datacenterCode=${datacenter_name}`, props) as any)?.data?.services;
                        instance_datasource?.map((val: any, key: any) => {
                            const {
                                serviceInstanceId,
                                serviceInstanceName,
                                subscriptionId,
                                transactionId,
                                serviceCategory,
                                userId,
                                serviceName,
                                datacenterCode,
                                servicePlanName,
                                createdAt,
                                dashboardUrl,
                                bindable,
                                subscriptionCompany,
                                subscriptionName,
                                lifecycleStatus,
                                userProvided
                            } = val;
                            lifecycleStatus?.toLowerCase() !== 'none' && list.push({
                                key: key,
                                instance_id: serviceInstanceId,
                                instance_name: serviceInstanceName,
                                subscriptionId: subscriptionId,
                                transactionId: transactionId,
                                serviceCategory: serviceCategory,
                                userId: userId,
                                service_name: serviceName,
                                datacenterCode: datacenterCode,
                                plan: servicePlanName,
                                status: lifecycleStatus,
                                creation_time_mp: format_time(createdAt),
                                dashboard_url: dashboardUrl,
                                bindable: bindable,
                                company: subscriptionCompany,
                                subscription_name: subscriptionName,
                                user_provided: userProvided
                            });
                            return list
                        });
                        set_instance_list?.(list);
                    } else {
                        Modal.warning({
                            style: { top: "200px" },
                            width: 430,
                            title: props.intl.formatMessage({ id: "restore_warn_title" },
                                { type: `${props.intl.formatMessage({ id: `${running_backup.length ? 'backup' : 'restore'}` })}` }),
                            content: props.intl.formatMessage({ id: "restore_warn_content" })
                        })
                    }
                })();
            }
        },
        {
            // ...delete_operation('delete', 'backup'),
            ...operation_status('delete_backup_management', 2, 'delete'),
            width: 600,
            modal_message: delete_backup_management_msg,
            handle_ok: ({ props }: modal_type) => {
                return {
                    key: "backup_management",
                    url: `/backup/dbBackups/${props?.item_selected?.db_backup_id}`
                };
            },
            // refresh_url: backup_management_refresh_url,
            // refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            // refresh_post_process: () => backup_post_process,
        },
        // Backup Configuration
        {
            ...operation_status('add_config', 0, 'create'),
            width: 785,
            modal_message: immediate_backup_msg,
            handle_ok: backup_handle_ok,
            refresh_url: backup_config_refresh_url,
            refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            refresh_post_process: () => backup_config_post_process
        },
        {
            ...operation_status('start_backup', 0, 'backup'),
            width: 650,
            modal_message: start_backup_msg,
            handle_ok: ({ props }: modal_type) => {
                const { item_selected } = props;
                const backup_body = {
                    // backup_config: form_value.backup_config,
                    // dbBackupName: form?.getFieldValue("backup_name"),
                    expiryDays: item_selected.manifest?.expiry_days,
                    description: item_selected.manifest?.description,
                    selectedDatabase: item_selected.selected_database,
                    instanceId: item_selected.manifest?.instance_id,
                    dbStorageId: item_selected.manifest?.db_storage?.id,
                    backupType: item_selected.backup_type,
                    advanced: {
                        start: item_selected.manifest?.advanced?.start,
                        end: item_selected.manifest?.advanced?.end,
                        shard: item_selected.manifest?.advanced?.shard,
                        retention: item_selected.manifest?.advanced?.retention,
                        force: true
                    }
                };

                return {
                    key: 'immediate_backup',
                    url: `/backup/dbBackups`,
                    body: backup_body
                };
            },
            initial_action: ({ set_disabled }: modal_type) => {
                set_disabled(false);
            }
            // refresh_url: backup_management_refresh_url,
            // refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            // refresh_post_process: () => backup_post_process
        },
        {
            ...operation_status('edit_config', 1, 'edit_config'),
            width: 785,
            modal_message: immediate_backup_msg,
            handle_ok: backup_handle_ok,
            refresh_url: backup_config_refresh_url,
            refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            refresh_post_process: () => backup_config_post_process
        },
        {
            ...operation_status('delete_config', 2, 'delete_config'),
            width: 630,
            modal_message: delete_config_msg,
            handle_ok: ({ props }: modal_type) => {
                return {
                    key: "backup_configuration",
                    url: `/backup/dbBackupConfigs/${props?.item_selected?.db_backup_config.id}`
                };
            },
            footer: ({ props, formatMessage }: modal_type) => {
                const { config_schedule_list, set_loading, set_loading_done, set_visible, set_action } = props;
                return config_schedule_list?.length ?
                    <Button type="primary" onClick={() => { set_visible?.(undefined); set_action?.(undefined) }}>OK</Button> :
                    <Fragment>
                        <Button key='cancel' onClick={() => { set_visible?.(undefined); set_action?.(undefined) }}>
                            {formatMessage({ id: 'cancel' })}
                        </Button>
                        <Button key='ok' type='primary' onClick={() => {
                            (async () => {
                                set_loading?.(true);
                                await http_request('backup_configuration', props, undefined, `/backup/dbBackupConfigs/${props?.item_selected?.db_backup_config.id}`, 3);
                                set_visible?.(undefined);
                                set_loading_done?.((current_state: { [key: string]: 0 | 1 }) => ({
                                    ...current_state,
                                    backup_configuration: 0
                                }));
                                set_loading?.(false);
                                // set_action?.(undefined);
                            })();
                        }}>
                            {formatMessage({ id: 'ok' })}
                        </Button>
                    </Fragment>
            },
            refresh_url: backup_config_refresh_url,
            refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            refresh_post_process: () => backup_config_post_process
        },
        // Restore Management
        //?
        {
            ...delete_operation('batch_delete', 'restore_management'),
            handle_ok: ({ props }: modal_type) => {
                props.set_selectable?.(0);
                return {
                    // url: `/v1/${(props.item_selected as { name: string } | undefined)?.name}`
                    url: ''
                };
            }
        },
        {
            ...operation_status("restore_details", 1, "details"),
            width: 850,
            modal_message: details_msg,
            footer: ({ props }: modal_type) => {
                return <Button type="primary" onClick={() => { props.set_visible?.(undefined) }}>OK</Button>
            }
        },
        {
            // ...delete_operation('delete', 'restore_management'),
            ...operation_status('delete_restore_management', 2, 'delete'),
            width: 620,
            modal_message: delete_backup_management_msg,
            handle_ok: ({ props }: modal_type) => {
                return {
                    key: "restore_management",
                    url: `/backup/dbRestores/${props.item_selected.db_restore_id}`
                };
            },
            // refresh_url: restore_refresh_url,
            // refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            // refresh_post_process: () => restore_post_process
        },
        //?
        // {
        //     ...operation_status('stop_restore', 1, 'stop_restore'),
        //     modal_message: stop_backup_msg,
        //     handle_ok: backup_handle_ok,
        //     initial_action: ({ set_disabled }: modal_type) => {
        //         set_disabled(false);
        //     }
        // },
        // Backup Schedule
        {
            ...operation_status('add_backup_schedule', 0, 'create'),
            modal_message: add_backup_schedule_msg,
            width: 750,
            handle_ok: backup_handle_ok,
            refresh_url: backup_schedule_refresh_url,
            refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            refresh_post_process: () => backup_schedule_post_process,
            initial_action: ({ props }: modal_type) => {
                props.set_item_selected?.(undefined);
            },
        },
        {
            ...operation_status('edit_backup_schedule', 1, 'edit_backup_schedule'),
            width: 750,
            modal_message: add_backup_schedule_msg,
            handle_ok: backup_handle_ok,
            // refresh_url: backup_schedule_refresh_url,
            // refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            // refresh_post_process: () => backup_schedule_post_process,
        },
        {
            // ...delete_operation('delete', 'backup_schedule'),
            ...operation_status('delete_backup_schedule', 2, 'delete'),
            width: 600,
            modal_message: delete_schedule_msg,
            handle_ok: ({ props }: modal_type) => {
                return {
                    key: "backup_schedule",
                    url: `/backup/dbSchedules/${props?.item_selected?.db_schedule.id}`
                };
            }
        },
        {
            ...operation_status('enable_backup_schedule', 1, 'enable'),
            modal_message: enable_backup_schedule_msg,
            handle_ok: backup_handle_ok,
            initial_action: ({ set_disabled }: modal_type) => {
                set_disabled(false);
            },
            refresh_url: backup_schedule_refresh_url,
            refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            refresh_post_process: () => backup_schedule_post_process
        },
        {
            ...operation_status('disable_backup_schedule', 1, 'disable'),
            modal_message: enable_backup_schedule_msg,
            handle_ok: backup_handle_ok,
            initial_action: ({ set_disabled }: modal_type) => {
                set_disabled(false);
            },
            refresh_url: backup_schedule_refresh_url,
            refresh_set_state: (props: { set_items: React.Dispatch<React.SetStateAction<table_list_type>> }) => props.set_items,
            refresh_post_process: () => backup_schedule_post_process
        }
    ]
}